const ignoreException = (e: Error) => {
  throw e
}

export default ignoreException
